import type { ImgHTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  alt: string
  width?: number | string
  height?: number | string
  fill?: boolean
  priority?: boolean
}

/** Drop-in stand-in for next/image used by ported marketing components. */
export function Image({ src, alt, width, height, fill, className, style, ...props }: ImageProps) {
  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn('absolute inset-0 h-full w-full object-cover', className)}
        style={style}
        {...props}
      />
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
      {...props}
    />
  )
}
